import {Injectable} from "@angular/core";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {ESystemActions, SetViewElementHeaderMode, SetViewElementSidebarMode, SetViewMode} from "../../actions/system/system.actions";
import {switchMap, withLatestFrom} from "rxjs/operators";
import {ConfigurationManager} from "../../../configuration-manager/configuration-manager";


@Injectable()
export class ViewModeEffects {
  setViewMode =  createEffect(() =>this._actions$.pipe(
    ofType<SetViewMode>(ESystemActions.SetViewMode),
    withLatestFrom(this._store$),
    switchMap(([action,storeState]) =>{
      const result = [];
      switch (action.payload) {
        case 'none':
          result.push(new SetViewElementSidebarMode('disabled'));

          result.push(new SetViewElementHeaderMode('none'));
          break;
        case 'initial':
          result.push(new SetViewElementSidebarMode('disabled'));

          result.push(new SetViewElementHeaderMode('none'));
          break;
        case 'login':
          result.push(new SetViewElementSidebarMode('disabled'));
          //на логине headerComponent показывается только на common login
          result.push(new SetViewElementHeaderMode(this.configurationManager.configuration.pagesConfig.login.loginType === 'common'?'login':'none'));

          break;
        case 'main':
          result.push(new SetViewElementSidebarMode('disabled'));
          //на логине headerComponent показывается только на common login
          result.push(new SetViewElementHeaderMode('main'));
          break;

        case 'normal':
          result.push(new SetViewElementSidebarMode('enabled'));
          //на логине headerComponent показывается только на common login
          result.push(new SetViewElementHeaderMode('common'));
          break;

        case 'mobileParam':
          result.push(new SetViewElementSidebarMode('disabled'));
          //на логине headerComponent показывается только на common login
          result.push(new SetViewElementHeaderMode('none'));
          break;
        case 'mobileProfile':
          result.push(new SetViewElementSidebarMode('disabled'));
          //на логине headerComponent показывается только на common login
          result.push(new SetViewElementHeaderMode('none'));
          break;

      }
      return result;
    })
  ));

  constructor(
    private _actions$: Actions,
    private _store$: Store<IAppState>,
    private configurationManager: ConfigurationManager
  ) {}
}
